import { Component, Input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ResearchService } from '../../services/research.service'
import { ResearchHistoryComponent } from '../research-history/research-history.component'
import { CommonModule } from '@angular/common'
import { TranslocoModule } from '@jsverse/transloco'
import { ConfigService } from '../../services/config.service'
import { DebugSidebarComponent } from '../debug-sidebar/debug-sidebar.component'
import { StatisticsService } from '../../services/statistics.service'

@Component({
   selector: 'app-sidebar',
   standalone: true,
   imports: [CommonModule, DebugSidebarComponent, RouterLink, ResearchHistoryComponent, TranslocoModule],
   templateUrl: './sidebar.component.html'
})
export class SidebarComponent {

   @Input() disclaimerLink = '/pages/disclaimer'
   @Input() helpLink = '/pages/help'
   @Input() libraryName!: string

   get debugEnabled() {
      return this.config.debug
   }

   constructor(private research: ResearchService, private config: ConfigService, private stats: StatisticsService){
   }

   startNewResearchSession() {
      this.research.startNewResearchSession()
      this.stats.sendEvent({ category: 'navigation', action: 'new-session', label: 'origin', value: 'sidebar' })
   }

   // this is a bit funky due to how primo is catching events for navigation. I want to also do the pageview thing
   log(action: string, url: string, alsoEmitEvent = true) {
      // also emit this, Primo depends on it
      this.stats.sendEvent({ category: 'navigation', action, label: 'url', value: url })
      if (alsoEmitEvent) {
         this.stats.pageView(url)
      }
   }
}
